var config = {
  src: 'background/strona_004.jpg',
  cropp: {
    pos: {
      x: -120,
      y: -1230,
      unit: 'px',
    },
    width: 1677,
    height: 660,
  },
};
export default config;
